import { cn } from "@/utils/utils";
import { Body } from "@hypercard/web-components";

export const AttributeKeyValueCell = ({
  keyName,
  value,
  className,
}: {
  keyName: string;
  value?: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn("w-full space-y-2", className)}>
      <Body size="sm" weight="regular" className="text-white/70">
        {keyName}
      </Body>
      <Body size="lg" weight="regular">
        {value}
      </Body>
    </div>
  );
};
